// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {BodyMono} from 'sail/Text';

const TextBlock = ({children}: {children: React.Node}) => (
  <Box
    style={{
      borderLeft: '2px solid #708eba',
      margin: '12px 0',
      padding: '8px 12px',
      background: 'rgba(19, 31, 65, 0.3)',
      maxWidth: 715,
    }}
  >
    <BodyMono color="gray200">{children}</BodyMono>
  </Box>
);

export default TextBlock;
